module.exports = __webpack_public_path__ + "static/media/mobix_moto.8e955982.png";